import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl, UntypedFormGroup, ValidatorFn } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/api.service';
import { NotificationModel } from '../notificationModel';
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppConstants } from 'src/app/app.constants';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';
import { ConfirmationModalComponent } from 'src/app/generic-components/confirmation-modal/confirmation-modal.component';
import { DateAdapter } from '@angular/material/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-edit-notification',
    templateUrl: './edit-notification.component.html',
    styleUrls: ['./edit-notification.component.css'],
    providers: [NgxSpinnerService]
})

export class EditNotificationComponent implements OnInit {
    roles = ["User","Admin","SecurityAgent","Supervisor"];
    @Input() set notiToUpdate(value: any) {
        this._notiToUpdate = value;
        if(this._notiToUpdate["scheduled"]){
            this.scheduleNoti = { option: "1" };
            //var eDate = this.functionsService.convertUTCDateToLocalDateUS(this._notiToUpdate["scheduled"]);
            //this.formatDateSchedule({value:new Date(eDate)});
            var fDate = this.functionsService.convertUTCDateToLocalDate(this._notiToUpdate["scheduled"], false);
            var splitter = fDate.split(" ");
            this.selectedDate = new Date(this._notiToUpdate["scheduled"]);
            this.selectedHour = splitter[1];
            this.getScheduleNoti(1);
            
        }
        this.addSelectedCheckboxes();
        this.editNotiForm.patchValue(value);
    }

    _notiToUpdate: any;
    editFormSubmitted: boolean = false;
    groupList = [];
    customGroups = [];
    selectedGroups = [];
    dropdownSettings = {};
    scheduleNoti = { option: "0" };
    hours = [];
    scheduleDate = "";
    currentDate: Date = new Date();
    editNotiForm: UntypedFormGroup;
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    selectedDate:any;
    selectedHour = "";
    selectedOptions = [];
    get message() { return this.controlGetter('message'); }
    //get userGroup() { return this.controlGetter('userGroup'); }

    constructor(
        private formBuilder: UntypedFormBuilder,
        public functionsService: FunctionsService,
        public activeModal: NgbActiveModal,
        private notification: NotificationModel,
        private translate: TranslateService,
        private apiService: ApiService,
        private modalService: NgbModal,
        public spinner: NgxSpinnerService,
        public constants: AppConstants,
        private deviceService: DeviceDetectorService,
        private dateAdapter: DateAdapter<Date>) { 
            this.editNotiForm = this.formBuilder.group({
                message: new UntypedFormControl('', Validators.compose([Validators.required, Validators.pattern(AppConstants.noLeadingRegEx)])),
                status: new UntypedFormControl(''),
                options: new UntypedFormArray([], this.minSelectedCheckboxes(1)),
                schedule: new UntypedFormControl(''),
                scheduleDate: new UntypedFormControl('')
            }); 
        }

    get optionsFormArray() {
        return this.editNotiForm.controls.options as UntypedFormArray;
    }

    private addSelectedCheckboxes() {
        this.constants.sendOptions.forEach((element) => {
            var fControl = this._notiToUpdate[element.id]?new UntypedFormControl(true):new UntypedFormControl(false);
            this.optionsFormArray.push(fControl)
        });
    }

    ngOnInit(){
        var orgId = this.functionsService.getOrg();
        this.hours = this.functionsService.hourDropDown(30);
        this.fetchGroups();
        this.dateAdapter.setLocale(this.language); 
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'tagId',
            textField: 'tagName',
            searchPlaceholderText: this.translate.instant('general.search'),
            noDataAvailablePlaceholderText: this.translate.instant('general.no_data_avail'), 
            selectAllText: this.translate.instant("general.select_all"),
            unSelectAllText: this.translate.instant("general.unselect_all"),
            itemsShowLimit: 5,
            allowSearchFilter: true
        };
        if(this._notiToUpdate["tagId"] && this._notiToUpdate["tagName"]!="All"){
            var tempId = this._notiToUpdate["tagId"].split(',');
            var tempName = this._notiToUpdate["tagName"].split(',');
            var i = 0;
            tempId.forEach(item => {
                this.selectedGroups.push({"tagId":item,"tagName":this.translate.instant(tempName[i])});
                i++;
            });
        }
        var role = "";
        for(var i=0; i<this.roles.length; i++){
            role = this.translate.instant(this.translate.instant(this.roles[i]));
            this.groupList.push({ tagId: this.roles[i]+"#"+orgId, tagName: role });
        }
    }

    private fetchGroups(){
        this.apiService.getGroups().subscribe(resp => {
            let jsonString = JSON.stringify(resp);
            let jsonObject = JSON.parse(jsonString);
            for(var i=0; i<jsonObject.length; i++){
                this.customGroups.push({ tagId: jsonObject[i].id.toString(), tagName: jsonObject[i].name });
            }
            this.groupList = this.groupList.concat(this.customGroups);
            if(this._notiToUpdate["tagName"]=="All"){
                this.selectedGroups = this.groupList;
            }
            
        }, error => this.functionsService.errorHandler(error["status"]));
    }

    changeStatus(){
        this.editNotiForm.value["status"] = 1;
    }

    editNotificationSave(){
        if(this.selectedGroups.length>0){this.userGroupValid()};
        document.getElementById('dpErrE').innerText = "";
        this.editNotiForm.value["message"] = this.editNotiForm.value["message"]?this.editNotiForm.value["message"].trim():"";
        const schedule = <HTMLInputElement>document.querySelector('input[name=schedule]:checked');
      
        if(schedule.value == "1"){
            //Format date and time and add to variable
            var time = (<HTMLInputElement>document.getElementById("hour")).value;
            
            var sd = this.functionsService.formatNotiDate(this.editNotiForm.value["scheduleDate"]);
            var datetime = new Date(sd+"T"+time);
            this._notiToUpdate.scheduled = datetime;
            if(this.deviceService.browser == "Safari" && parseFloat(this.deviceService.browser_version) < 14){
                var timeOffset = new Date().getTimezoneOffset();       
                var d = new Date((datetime).getTime() + (timeOffset*60*1000));  
                this._notiToUpdate.scheduled = new Date(d);
            }
        }else{
            this._notiToUpdate.scheduled = null;
        }
        if (!this.editNotiForm.valid || this.selectedGroups.length==0 || this.editNotiForm.value["message"] == "" || (schedule.value == "1" && (!this.editNotiForm.value["scheduleDate"]|| (this._notiToUpdate.scheduled<=this.currentDate)))) {
            if(this.selectedGroups.length==0)
            {    
                document.getElementById('userGroupErrE').innerText = this.translate.instant('general.required_field');
            }
            
            if(schedule.value == "1" && !this.editNotiForm.value["scheduleDate"]){
                document.getElementById('dpErrE').innerText = this.translate.instant('general.required_field');
            }
            else if(schedule.value == "1" && (this._notiToUpdate.scheduled<=this.currentDate)){
                document.getElementById('dpErrE').innerText = this.translate.instant('general.invalid_datetime');
            }
            this.editFormSubmitted = true;
            return;
        } 
        
        this._notiToUpdate.TagId = "";
        this._notiToUpdate.TagName = "";
        var nameSplit;
        this.selectedGroups.forEach(element => {
            nameSplit = element['tagId'].split('#');
            element['tagName'] = (nameSplit.length>1)?nameSplit[0]:element['tagName'];
            this._notiToUpdate.TagId += element['tagId']+",";
            this._notiToUpdate.TagName += element['tagName']+",";
        });
        this._notiToUpdate.TagId = this._notiToUpdate.TagId.slice(0, -1); 
        this._notiToUpdate.TagName = this._notiToUpdate.TagName.slice(0, -1); 
        Object.assign(this._notiToUpdate, this.editNotiForm.value);
        
        this._notiToUpdate.status = this.editNotiForm.value["status"];
        this._notiToUpdate.pushNotification = this.selectedOptions[0];
        this._notiToUpdate.emailNotification = this.selectedOptions[1];
        this._notiToUpdate.sMS = this.selectedOptions[2];
        this._notiToUpdate.voiceCall = this.selectedOptions[3];
        
        var groupArray = this._notiToUpdate.TagId.split(',');
        var content = {
            "ContentIos":"{\"aps\":{\"alert\":{\"title\": \"Contigo MSJ\",\"body\": \""+ this._notiToUpdate.message +"\"},\"sound\":\"default\",\"category\": \"Alert\",\"content-available\": 1,\"mutable-content\": 1}}",
            // "ContentAndroid":"{\"data\":{\"message\":\"" + this._notiToUpdate.message +"\"}}",
            "ContentAndroid":"{\"message\":{\"android\":{\"data\":{\"message\":\"" +  this._notiToUpdate.message + "\"}}}}",
            "TagInput": groupArray,
            "NotificationId": this._notiToUpdate.id,
            "Message": this._notiToUpdate.message,
            "PushNotification": this._notiToUpdate.pushNotification,
            "EmailNotification": this._notiToUpdate.emailNotification,
            "SMS": this._notiToUpdate.sms,
            "VoiceCall":this._notiToUpdate.voiceCall
        };
        
        if(this.selectedGroups.length==this.groupList.length){
            this._notiToUpdate.TagId = "All";
            this._notiToUpdate.TagName = "All";
        } 
        this.spinner.show();
        if(this.editNotiForm.value["status"]==1){
            this.sendNotificationPrompt(this._notiToUpdate,content);
        }
        else {
            this.editNotification(this._notiToUpdate,content,0);
        }
    }

    editNotification(notification, content, status){
        if(this.selectedGroups.length>0){this.userGroupValid()};
        this.apiService.editNotification(notification).subscribe(
            () => {
                notification["status"] = status;
                switch(status){
                    case 1:
                        if(notification.tagName=="All"){
                            notification.tagId = "";
                            var name ="";
                            this.groupList.forEach(element => {
                                name = element['tagId'].split('&');
                                notification.tagId = notification.tagId+name[0]+",";
                            });
                            notification.tagId = notification.tagId.slice(0, -1); 
                        }
                        this.sendNotification(content);
                        break;
                    case 2:
                    case 3:
                        this.apiService.updateSentStatus(notification).subscribe(
                            () => {
                                this.spinner.hide();
                                this.activeModal.close();
                            },
                            error => {
                                this.spinner.hide();
                                this.functionsService.errorHandler(error["status"]);
                            }
                        );
                        break;
                    default: 
                        this.spinner.hide();
                        this.activeModal.close();
                        break;
                }
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    sendNotificationPrompt(notification,content){
        if(!notification.TagName){
            this.spinner.hide();
            const okModalRef = this.modalService.open(OkModalComponent);
            okModalRef.componentInstance.title = this.translate.instant('notification.invalid_group');
            okModalRef.componentInstance.message = this.translate.instant('notification.select_valid_group');
            return;
        }

        this.apiService.approveNotificationsStatus().subscribe(
            data => {
                this.spinner.hide();
                const confirmModalRef = this.modalService.open(ConfirmationModalComponent);
                if(data["approve"]){
                    if(notification.scheduled){ 
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.schedule_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_schedule_prompt') + `"${notification.message}"` + this.translate.instant('notification.to_send_to') + this.functionsService.formatMultiGroupName(notification.TagName)+"? <br>"+ this.translate.instant('notification.sent_once_approved_scheduling');
                    }
                    else{
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.send_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_not_prompt') + `"${notification.message}"` + this.translate.instant('general.to') + this.functionsService.formatMultiGroupName(notification.TagName)+"? <br>"+ this.translate.instant('notification.sent_once_approved');
                    }

                    confirmModalRef.result.then(confirmed => {
                        if (confirmed) {
                            this.spinner.show();
                            this.editNotification(notification,content,2);
                        }
                    });
                }
                else{
                    if(notification.scheduled){ 
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.schedule_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_schedule_prompt') + `"${notification.message}"` + this.translate.instant('notification.to_send_to') + this.functionsService.formatMultiGroupName(notification.TagName)+"?";
                        confirmModalRef.result.then(confirmed => {
                            if (confirmed) {
                                this.spinner.show();
                                this.editNotification(notification,content,3);
                            }
                        });
                    }
                    else{
                        confirmModalRef.componentInstance.title = this.translate.instant('notification.send_notification');
                        confirmModalRef.componentInstance.message = this.translate.instant('notification.send_not_prompt') + `"${notification.message}"`+this.translate.instant('general.to')+this.functionsService.formatMultiGroupName(notification.TagName)+"?";
                        confirmModalRef.result.then(confirmed => {
                            if (confirmed) {
                                this.spinner.show();
                                this.editNotification(notification,content,1);
                            }
                        });
                    }
                }
            }
        );
    }

    sendNotification(content){
        this.spinner.show();
        if(this.selectedGroups.length>0){this.userGroupValid()};
        this.apiService.sendNotificationOptions(content).subscribe(
            () => {
                this.activeModal.close();
                this.spinner.hide();
            },
            error => {
                this.spinner.hide();
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    private minSelectedCheckboxes(min = 1) {
        const validator: ValidatorFn = (formArray: UntypedFormArray) => {
          const totalSelected = formArray.controls
            // get a list of checkbox values (boolean)
            .map(control => control.value)
            // total up the number of checked checkboxes
            .reduce((prev, next) => next ? prev + next : prev, 0);
            this.selectedOptions = formArray.controls.map(control => control.value)
            if(document.getElementById('optionsErrE')){
                if(!(totalSelected >= min)){
                    document.getElementById('optionsErrE').innerText = this.translate.instant('notification.one_option_err');
                }else{
                    document.getElementById('optionsErrE').innerText = "";
                }
            }
          // if the total is not greater than the minimum, return the error message
          return totalSelected >= min ? null : { required: true };
        };
      
        return validator;
    }

    getScheduleNoti(value){
        if(value==1){
            document.getElementById("scheduled_yes_m").hidden = false;
            document.getElementById("send_m").hidden = true;
            document.getElementById("schedule").hidden = false;
            document.getElementById("update").hidden = true;
        }else{
            document.getElementById("scheduled_yes_m").hidden = true;
            document.getElementById("send_m").hidden = false;
            document.getElementById('dpErrE').innerText = "";
            document.getElementById("schedule").hidden = true;
            document.getElementById("update").hidden = false;
        }
    }

    formatDateSchedule(event){
        var sd = new Date(event.value);
        this.scheduleDate = (sd.getMonth()+1)+"-"+sd.getDate()+"-"+sd.getFullYear();
        document.getElementById('dpErrE').innerText = "";
    }

    onItemSelect(item: any) {
        document.getElementById('userGroupErrE').innerText = "";
        this.selectedGroups.push();
        this.userGroupValid();
    }

    onSelectAll(items: any) {
        this.selectedGroups = [];
        items.forEach(element => {
            this.selectedGroups.push(element);
        });
        document.getElementById('userGroupErrE').innerText = "";
        this.userGroupValid();
    }

    onItemDeSelect(item: any) {
        const index: number = this.selectedGroups.indexOf(item);
        if (index !== -1) {
            this.selectedGroups.splice(index, 1);
        }   
        if(this.selectedGroups.length==0){
            this.userGroupErr();
        }
    }

    onDeSelectAll(items: any) {
        this.selectedGroups = [];
        this.userGroupErr();
    }

    userGroupValid(){
        let elements = document.getElementsByClassName("dropdown-btn");
        let display = elements.item(0) as HTMLElement;
        display.style.border = "1px solid #28a745";
        document.getElementById('userGroupErrE').innerText = "";
    }

    userGroupErr(){
        let elements = document.getElementsByClassName("dropdown-btn");
        let display = elements.item(0) as HTMLElement;
        display.style.border = "1px solid #dc3545";
        document.getElementById('userGroupErrE').innerText = this.translate.instant('general.required_field');
    }

    controlGetter(controlName) {
        const control =  this.editNotiForm.get(controlName);
        return control && (control.touched || this.editFormSubmitted) ? control : {};
    }
}